module.exports = __webpack_public_path__ + "static/media/MyInstituteIntro.d7af5d37.svg";